// extracted by mini-css-extract-plugin
export var centered = "_k-6";
export var flexible = "_k-5";
export var footer = "_k-k";
export var footerBorder = "_k-l";
export var header = "_k-c";
export var headerBorder = "_k-d";
export var headerDefault = "_k-g";
export var headerMedium = "_k-h";
export var headerPadding = "_k-e";
export var iconAndTitle = "_k-f";
export var large = "_k-4";
export var largePadding = "_k-a";
export var medium = "_k-3";
export var mediumPadding = "_k-9";
export var modal = "_k-0";
export var modalContainer = "_k-b";
export var noPadding = "_k-7";
export var skinny = "_k-1";
export var small = "_k-2";
export var smallPadding = "_k-8";
export var subtitle = "_k-j";
export var title = "_k-i";